import { createSelector } from 'reselect';
import get from 'lodash/get';
import { workflowSubdivision } from '../AdvWorkflow/AdvWorkflowSelector';
import { DistributionStrategyTypeEnum } from './DecumulationWorkflow.constants';

export const selectDistributionStrategyType = createSelector(
  workflowSubdivision,
  (subdivision = {}) =>
    get(
      subdivision,
      'data.DecumulationGoal.DistributionStrategyType',
      DistributionStrategyTypeEnum.Percentage,
    ),
);

export const selectDistributionPercentage = createSelector(
  workflowSubdivision,
  (subdivision = {}) => get(subdivision, 'data.DecumulationGoal.DistributionPercentage', null),
);

export const selectDistributionDollarAmount = createSelector(
  workflowSubdivision,
  (subdivision = {}) => get(subdivision, 'data.DecumulationGoal.DistributionDollarAmount', null),
);

export const selectDistributionYears = createSelector(workflowSubdivision, (subdivision = {}) =>
  get(subdivision, 'data.DecumulationGoal.DistributionYears', null),
);

export const selectIsDecumulationGoalValid = createSelector(
  selectDistributionStrategyType,
  selectDistributionPercentage,
  selectDistributionDollarAmount,
  selectDistributionYears,
  (
    distributionStrategyType,
    distributionPercentage,
    distributionDollarAmount,
    distributionYears,
  ) => {
    if (
      distributionStrategyType === DistributionStrategyTypeEnum.Percentage &&
      distributionPercentage === null
    ) {
      return false;
    }

    if (
      distributionStrategyType === DistributionStrategyTypeEnum.Dollar &&
      distributionDollarAmount === null
    ) {
      return false;
    }

    if (distributionYears === null) {
      return false;
    }

    return true;
  },
);
